import { getPlaidLink, getSyncingStatus, linkPlaidConnection, setConnectionsStatus, } from 'actions';
import { useCallback } from 'react';
import { selectConnections, selectIsLoggedIn } from 'reducers/selectors';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { openPlaid } from 'utils/plaidlink';
import useLinkedConnection from 'features/link-bank/hooks/useLinkedConnection';
import useAppRating from './useAppRating';
const usePlaidLink = () => {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const rateApp = useAppRating();
    const { handleLinkedConnection } = useLinkedConnection();
    const open = useCallback((business) => {
        const state = store.getState();
        const isLoggedIn = selectIsLoggedIn(state);
        openPlaid(() => dispatch(getPlaidLink(business, isLoggedIn)), (data) => dispatch(linkPlaidConnection(data)), (isSuccess) => {
            if (isLoggedIn && isSuccess) {
                handleLinkedConnection();
            }
            else {
                dispatch(setConnectionsStatus(true));
                if (state.user.isLoggedIn && selectConnections(state).length >= 1) {
                    rateApp();
                }
                dispatch(getSyncingStatus());
            }
        });
    }, [handleLinkedConnection, rateApp]);
    return open;
};
export default usePlaidLink;
